import React from "react";

/*
 * Component to display telephone number links
 */
export function PhoneLink(props) {
    let phoneHref = "tel:" + props.phoneNumber; //formatPhoneNumber from helpers

    return (<a className="phone-link" href={phoneHref} >
        <span className="details-icon-prepend">
            <span className="icon-col"><span className="icon-phone"></span></span>
            <span className="details-col">{props.phoneNumber}</span>
        </span>
    </a>);
}
